import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(null); // null = checking, object = authed, false = anon

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setAuth(data);
      return data;
    } catch {
      setAuth(false);
      return false;
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setAuth(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setAuth(false);
  };

  return (
    <AuthContext.Provider value={{ auth, setAuth, login, logout, loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}
